export default __webpack_public_path__ + "static/media/Solitary Verbal Learner.4cb28af6.png";